import createModule from "../createModule"
import { getError, getToken, getName, getEmail } from "./selectors"
import { Creators } from "./model"
import view from "./view"

export default createModule({
  view,
  mapStateToProps: (state, props) => ({
    error: getError(state, props),
    token: getToken(state, props),
    name: getName(state, props),
    email: getEmail(state, props),
  }),
  actions: {
    ...Creators,
  },
})
